import React, { createContext, useEffect, useState } from 'react';

import { useWallet } from 'use-wallet';
import Web3 from 'web3';
import { provider } from 'web3-core';

export interface Web3ContextI {
    web3: any;
}

export const Web3Context = createContext<Web3ContextI>({ web3: null });

const Web3Provider = ({ children }) => {
    const { ethereum, connect, error, status } = useWallet<provider>();
    const [web3, setWeb3] = useState<any>();
    const wrongNetwork = status == 'error' && error && error.toString().indexOf('ChainUnsupportedError') >= 0;
    const [prevWrongNetwork, setPrevWrongNetwork] = useState<any>(wrongNetwork);

    useEffect(() => {
        if (wrongNetwork !== prevWrongNetwork && error) {
            setPrevWrongNetwork(wrongNetwork);
        }
    }, [wrongNetwork]);

    useEffect(() => {
        if (ethereum) setWeb3(new Web3(ethereum));
        else {
            connect('injected');
        }
    }, [ethereum]);

    return (
        <Web3Context.Provider
            value={{
                web3,
            }}
        >
            {children}
        </Web3Context.Provider>
    );
};

export default Web3Provider;
